
[
  {
    "id": "WW-L3-005",
    "module": "SpellingWW",
    "difficulty": 201,
    "question": "Voltooid deelwoord: De wedstrijd is vroeg ..... (eindigen).",
    "options": ["geëindigd", "geëindigt", "eindigde", "eindigt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_geen_kofschip",
    "familyId": "WW-VD-EINDIGEN",
    "explanation": "Grondwoord = eindig. G zit NIET in 't kofschip. Dus heb-vorm met -d: geëindigd.",
    "distractorExplanations": { "1": "Je schrijft een d, geen t. (Test: geëindig-de klinkt goed).", "2": "Dit is verleden tijd (eindigde), niet de heb-vorm.", "3": "Dit is nu (tegenwoordige tijd)." },
    "visualAid": { "type": "rule", "data": { "title": "Heb-vorm (Voltooid Deelwoord)", "content": "Geen 't kofschip letter? Dan -d. Heeft geëindigd.", "icon": "book" }, "showWhen": "wrong" }
  },
  {
    "id": "WW-B7-L4-001",
    "module": "SpellingWW",
    "difficulty": 201,
    "question": "Voltooid deelwoord: De wedstrijd is live ..... (uitzenden).",
    "options": ["uitgezonden", "uitzend", "uitzond", "uitzending"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_sterk",
    "familyId": "WW-VD-UITZENDEN",
    "explanation": "'Uitzenden' is een onregelmatig werkwoord (zenden → gezonden). Het voltooid deelwoord is dus 'uitgezonden'. Let op: bij scheidbare werkwoorden komt 'ge-' tussen het voorvoegsel en de stam: uit + ge + zonden.",
    "distractorExplanations": { "1": "Dit is de tegenwoordige tijd (ik zend uit), niet het voltooid deelwoord.", "2": "Dit is de verleden tijd (hij zond uit), niet het voltooid deelwoord.", "3": "Dit is een zelfstandig naamwoord, geen werkwoordsvorm." },
    "visualAid": { "type": "rule", "data": { "title": "Onregelmatig werkwoord", "content": "Zenden → zond → gezonden. Bij 'uitzenden' komt ge- ertussen: uit-ge-zonden.", "icon": "book" }, "showWhen": "wrong" }
  }
]
